import { AppName } from "@/constants/application/application"
import { WorkflowStepType } from "@/constants/workflows/workflowCreate"
import { FieldsResponse, FieldsTree } from "@/types/WorkflowCreate/fields"

// TODO Remove after test in Sandbox
export const getAllGetFieldsFromEveryApps = (
  data: Partial<Record<string, FieldsResponse>>,
  appNames: string[]
): Record<string, FieldsTree> => {
  const output: Record<string, FieldsTree> = {}

  Object.keys(data).forEach((app) => {
    if (data[app as AppName] && (appNames.includes(app as AppName) || app.includes(WorkflowStepType.TRANSFORMATION))) {
      if (!output[app]) output[app] = {}

      data[app as AppName]?.responseFields.forEach((fieldGroup) => {
        if (fieldGroup.fields && fieldGroup.fields.length > 0) {
          fieldGroup.fields.forEach((group) => {
            if (group.fields && group.fields.length > 0) {
              // Nested sub-fields
              group.fields.forEach((subField) => {
                // Ensure fieldGroup branch
                if (
                  typeof output[app][fieldGroup.displayName] !== 'object' ||
                  output[app][fieldGroup.displayName] === null
                ) {
                  output[app][fieldGroup.displayName] = {}
                }
                const fieldGroupBranch = output[app][fieldGroup.displayName] as FieldsTree

                // Ensure group branch
                if (
                  typeof fieldGroupBranch[group.displayName] !== 'object' ||
                  fieldGroupBranch[group.displayName] === null
                ) {
                  fieldGroupBranch[group.displayName] = {}
                }
                const groupBranch = fieldGroupBranch[group.displayName] as FieldsTree

                // Set subField
                groupBranch[subField.displayName] = `${app}=>${subField.codeChain || subField.code}`
              })
            } else {
              // group is a leaf
              if (
                typeof output[app][fieldGroup.displayName] !== 'object' ||
                output[app][fieldGroup.displayName] === null
              ) {
                output[app][fieldGroup.displayName] = {}
              }
              const fieldGroupBranch = output[app][fieldGroup.displayName] as FieldsTree

              fieldGroupBranch[group.displayName] = `${app}=>${group.codeChain || group.code}`
            }
          })
        } else {
          // fieldGroup is a leaf
          output[app][fieldGroup.displayName] = `${app}=>${fieldGroup.codeChain || fieldGroup.code}`
        }
      })
    }
  })

  return output
}

// TODO Remove after test in Sandbox
export const getSaveableFields = (
  data: Partial<Record<string, FieldsResponse>>,
  destinationApp: string
) => {
  const output: Record<string, FieldsTree> = {}

  const fieldGroups = data[destinationApp]
  if (!fieldGroups) return output

  data[destinationApp]?.requestFields.forEach(fieldGroup => {
    if (fieldGroup.fields && fieldGroup.fields.length > 0) {
      // parent with nested fields
      output[fieldGroup.displayName] = fieldGroup.fields.reduce((acc, field) => {
        acc[field.displayName] = field.codeChain || field.code
        return acc
      }, {} as Record<string, string>)
    } else {
      // fieldGroup is itself a field
      output[fieldGroup.displayName] = `${fieldGroup.codeChain || fieldGroup.code}` as unknown as FieldsTree
    }
  })

  return output
}

export const getGettableFields = (
  data: Partial<Record<AppName, FieldsResponse>>,
  destinationApp?: AppName
) => {
  const output: Record<string, FieldsTree> = {}

  const fieldGroups = data[destinationApp as AppName]
  if (!fieldGroups) return output

  data[destinationApp as AppName]?.responseFields.forEach(fieldGroup => {
    if (fieldGroup.fields && fieldGroup.fields.length > 0) {
      // parent with nested fields
      output[fieldGroup.displayName] = fieldGroup.fields.reduce((acc, field) => {
        acc[field.displayName] = field.codeChain || field.code
        return acc
      }, {} as Record<string, string>)
    } else {
      // fieldGroup is itself a field
      output[fieldGroup.displayName] = `${fieldGroup.codeChain || fieldGroup.code}` as unknown as FieldsTree
    }
  })

  return output
}

// TODO Remove after test in Sandbox
export const getAllIterableFieldsFromEveryApps = (
  data: Partial<Record<string, FieldsResponse>>,
  appNames: string[]
) => {
  const output: Record<string, FieldsTree> = {}
  Object.keys(data).forEach((app) => {
    if (data[app as AppName] && appNames.includes(app as AppName)) {
      if (!output[app as AppName]) output[app as AppName] = {}
      data[app as AppName]?.responseFields.forEach((fieldGroup) => {
        if (fieldGroup.type === 'ARRAY') {
          output[app as AppName][fieldGroup.displayName] = fieldGroup.codeChain || fieldGroup.code;
        }
      });
    }
  })

  return output
}
